import {RootState} from '../store';

export const lightAppsListSelector = (state: RootState) => state.lightAppsByCategories;
